import './SalesInvoiceAdd.scss';
import React, { useEffect, useState } from 'react';
import Heading from '../../common/Heading/Heading';
import {
  App,
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Descriptions,
  Divider,
  Dropdown,
  Flex,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Spin,
  TimePicker,
} from 'antd';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../../services/react-query/queryKeys';
import dayjs from 'dayjs';
import { useNavigate, useParams } from 'react-router-dom';
import {
  AddcreditNote,
  addSalesInvoice,
  cancelSalesInvoice,
  creditSalesInvoice,
  downloadZatca,
  downloadZatcaXml,
  getPrintFormat,
  getSalesInvoiceDetails,
  getSalesOrder,
  getVatTax,
  getZatcaDetails,
  submitSalesInvoice,
  submitToZatca,
  updateSalesInvoice,
} from '../../../network/salesInvoice';
import { useSelector } from 'react-redux';
import {
  ModalAppPayment,
  ModalAppPdfData,
  ModalGetLinkedDocs,
  ModalTodoList,
} from '../ModalApp/ModalApp';
import { FakeInvoice } from '../../../utils/constants';
import {
  CheckOutlined,
  DownloadOutlined,
  DownOutlined,
} from '@ant-design/icons';
import ItemListSalesInvoice from './ItemListSalesInvoice';
import TaxesandChargesList from './TaxesandChargesList';
import {
  getGetDetailsApi,
  getSearchApi,
  getSearchApiSearchText,
} from '../../../network/itemList';
import PaymentSchedule from '../AddPurchaseOrder/PaymentSchedule';
import { getCustomer } from '../../../network/customer';
import {
  createFullInvoice,
  createPartialSalesInvoice,
} from '../../../network/salesOrder';
import { submitMaterialRequest } from '../../../network/materialRequest';
import TaxtList from '../AddPurchaseOrder/TaxtList';
import { getVATDetails } from '../../../network/purchaseOrder';
import ItemOrderList from '../AddPurchaseOrder/ItemOrderList';
import { MdAssignmentAdd, MdOutlinePayment } from 'react-icons/md';
import { FaFileInvoice, FaMoneyBillWave } from 'react-icons/fa';
import { GiFiles } from 'react-icons/gi';
import UseDownloadPdf from '../../../hooks/DownloadPdf';
import { FaMoneyBillTrendUp } from 'react-icons/fa6';
import HeadingApp from '../../../hooks/HeadingApp';
import StatusTag from '../../../hooks/StatusHook';
import { TiCancel } from 'react-icons/ti';
import { getSearchPatients } from '../../../network/appointment';
const SalesInvoiceAdd = ({ t, edit, salesOrder, SalesFullPayment, credit }) => {
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [searchTxt, setSearchTxt] = useState('');
  const [openTask, setOpenTask] = useState(false);
  const [idTask, setIdTask] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [dataSourceItem, setDataSourceItem] = useState([{}]);
  const [total, setTotal] = useState(0);
  const [searchtextCustomer, setSearchtextCustomer] = useState('');
  const [dataSourcePayment, setDataSourcePayment] = useState([
    {
      invoice_portion: 100,
      due_date: dayjs(),
    },
  ]);
  const [nameInvoiceZatca, setNameInvoiceZatca] = useState('');
  const [dataStatus, setDataStatus] = useState(null);
  const [dataSourceTax, setDataSourceTax] = useState([{}]);
  const [searchTxtPractitionerTxt, setSearchPractitionerTxt] = useState('');
  const [editId, setEditId] = useState(null);
  const [openPdfZatca, setOpenPdfZatca] = useState(false);
  const [openLinkedDocs, setOpenLinkedDocs] = useState(null);
  const [nameSalesInvoice, setNameSalesInvoice] = useState(null);
  const [taxesDetails, setTaxesDetails] = useState([]);
  const [loadingTaxesDetails, setLoadingTaxesDetails] = useState(false);
  const [totalPayment, setTotalPayment] = useState(0);
  const disountApplyType = Form.useWatch('discount_type', form);
  const { currentLang, companyName } = useSelector((state) => state.user);
  const { id, idSalesOrder, idFullPayment, idAmount, idOrder } = useParams();
  const client = useQueryClient();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const [searchTxtBranch, setSearchTxtBranch] = useState('');
  const [invoiceNumber, setInvoiceNumber] = useState(null);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [submitButton, setSubmitButton] = useState(false);
  const [zatcaData, setZatcaData] = useState(null);
  const [openPdf, setOpenPdf] = useState(false);
  const { message } = App.useApp();
  const navigate = useNavigate();
  const watchPriceList = Form.useWatch('selling_price_list', form);
  const { mutate: onAddSalesInvoice } = useMutation({
    mutationKey: ['addSalesInvoice'],
    mutationFn: (body) =>
      edit ? updateSalesInvoice(body, id) : addSalesInvoice(body),
    onSuccess: (data) => {
      // console.log(data, 'datarrrrrrrrrrrrrrrrrrrrrrrrrrr');
      setLoadingAdd(false);
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(edit ? 'Edited successfully' : 'Added successfully');
      setInvoiceNumber(edit ? id : data?.data?.name);
      setSubmitButton(true);
      client.invalidateQueries({
        queryKey: [queryKeys.getSalesInvoices],
      });
      // form.resetFields();
      edit && dataStatus !== 0 && navigate('/sales-invoice');
    },

    onError: (error) => {
      setLoadingAdd(false);
      console.log('error:', error);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
    },
  });
  const { mutate: onCreditSalesInvoice } = useMutation({
    mutationKey: ['onCreditSalesInvoice'],
    mutationFn: (data) => creditSalesInvoice(id),
    onSuccess: async (data) => {
      // console.log(data, 'data');
      // console.log(data?.message, 'data messagemessagemessage');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        setLoadingSubmit(false);
        return false;
      } else {
        const response = await addSalesInvoice({
          ...data?.data,
        });
        setLoadingSubmit(false);

        // console.log(response, 'responseresponse ');
        if (response?.message?.status === 500) {
          message.error(response?.message?.message);
          return false;
        } else {
          message.success(response?.message?.message);
          navigate(`/sales-invoice/${response?.message?.invoice_number}`);
        }
      }
    },
    onError: (error) => {
      console.log(error, 'error');
      setLoadingAdd(false);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
    },
  });
  const { mutate: onGetTaxes, data: taxesList } = useMutation({
    // mutationFn: (name) => getVATDetails('Purchase', name),
    mutationFn: (name) => getVATDetails('Sales', name),
    onSuccess: (data) => {
      console.log(data, 'data');
      setLoadingTaxesDetails(false);
      setTaxesDetails(data?.message);
      setDataSourceTax(data?.message);
    },
    onError: (error) => {
      console.log(error, 'error');
    },
  });
  const { mutate: onSubmitToZatca } = useMutation({
    mutationKey: ['submitToZatca'],
    mutationFn: (name) => submitToZatca(name),
    onSuccess: (data) => {
      //  console.log(data, 'data');
      console.log(data?.message, 'data');
      //  console.log(data?.message?.status, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      data?.message?.message && message.success(data?.message?.message);
      client.invalidateQueries({
        queryKey: [queryKeys.getSalesInvoices],
      });
    },
    onError: (error) => {
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
    },
  });
  const { onGetPDF, pdfData, setLoadingPdf, loadingPdf } = UseDownloadPdf();
  const handleCancelSalesInvoice = useMutation({
    mutationFn: (id) => cancelSalesInvoice(id),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      client.invalidateQueries({
        queryKey: [queryKeys.getSalesInvoiceDetails, id],
      });
      message.success(data?.message?.message || 'Cancelled successfully');
    },
    onError: () => {
      setLoadingAdd(false);
      message.error('حدث خطأ ما');
    },
  });
  const { mutate: onDownloadZatca, data: pdfDataZatca } = useMutation({
    mutationKey: ['downloadZatca'],
    mutationFn: ({ type, name, lang, format }) =>
      downloadZatca({ type, name, lang, format }),
    onSuccess: (data) => {
      console.log(data, 'data onDownloadZatca');
      console.log(data?.message, 'data');
      //  console.log(data?.message?.status, 'data');
      setLoadingPdf(false);
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      // message.success('Download successfully');
      client.invalidateQueries({
        queryKey: [queryKeys.getSalesInvoices],
      });
    },
    onError: (error) => {
      setLoadingPdf(false);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
    },
  });
  const { mutate: onDownloadZatcaXml } = useMutation({
    mutationKey: ['downloadZatcaXml'],
    mutationFn: (name) => downloadZatcaXml(name),
    onSuccess: (response, name) => {
      const xmlContent = response.data;

      console.log('First 100 XML Chars:', xmlContent.slice(0, 100));

      const blob = new Blob([xmlContent], {
        type: 'application/xml;charset=utf-8',
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `invoice-${name}.xml`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      message.success('Download successfully');
      client.invalidateQueries({
        queryKey: [queryKeys.getSalesInvoices],
      });
    },
    onError: (error) => {
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
    },
  });
  const { mutate: onGetZatcaDetails } = useMutation({
    mutationKey: ['getZatcaDetails'],
    mutationFn: (name) => getZatcaDetails(name),
    onSuccess: (data) => {
      const msg = data?.message?.[0];
      let validationResults = [];
      if (msg?.status === 500) {
        message.error(msg?.message);
        return;
      }

      // setZatcaData({
      //   status: msg?.status,
      //   zatca_status: msg?.zatca_status,
      //   validationResults: JSON.parse(msg?.zatca_message),
      // });
      const parsedMessage = JSON.parse(msg.zatca_message);
      const results = parsedMessage?.validationResults ?? {};

      const allMessages = [
        ...(Array.isArray(results.infoMessages) ? results.infoMessages : []),
        ...(Array.isArray(results.warningMessages)
          ? results.warningMessages
          : []),
        ...(Array.isArray(results.errorMessages) ? results.errorMessages : []),
      ];

      validationResults = allMessages.map((item) => ({
        type: item.type,
        message: item.message,
      }));
      setZatcaData({
        status: msg?.status,
        zatca_status: msg?.zatca_status,
        validationResults,
      });
      setModalOpen(true);
    },
    onError: (error) => {
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
    },
  });
  const { mutate: onSubmitSalesInvoice, isLoading: isLoadingSubmit } =
    useMutation({
      mutationKey: ['submitSalesInvoice'],
      mutationFn: (name) => submitMaterialRequest('Sales Invoice', name),
      onSuccess: (data) => {
        setLoadingAdd(false);
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        data?.message?.message && message.success(data?.message?.message);
        submitButton && navigate('/sales-invoice');
        client.invalidateQueries({
          queryKey: [queryKeys.getSalesInvoiceDetails, id],
        });
      },
      onError: (error) => {
        setLoadingAdd(false);
        console.log(error);

        // message.error(error);
      },
    });
  const handleCreditNote = useMutation(
    // (id) => deletePatient(id),
    {
      mutationFn: (name) => AddcreditNote(name),
      onSuccess: (data) => {
        console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        if (data?.message) {
          onAddSalesInvoice(data?.message);
        } else {
          message.error('Something went wrong!');
        }
      },
    }
  );
  const { mutate: handleGetDetails } = useMutation({
    mutationKey: [queryKeys.getSearchApiAccountList],
    mutationFn: (values) =>
      getGetDetailsApi({
        type: 'Customer',
        name: values,
        fields: [
          // 'customer_name_in_arabic',
          'customer_name',
          'tax_id',
          'custom_vat_registration_number',
          // 'custom_b2c',
          'customer_primary_address',
          // 'address_html',
          // 'address_display',
        ],
      }),
    onSuccess: (data) => {
      form.setFieldsValue({
        // customer_name_in_arabic: data?.message?.customer_name_in_arabic,
        customer_name: data?.message?.customer_name,
        tax_id: data?.message?.tax_id,
        // custom_b2c: data?.message?.custom_b2c,
        custom_vat_registration_number:
          data?.message?.custom_vat_registration_number,
      });
    },
  });
  const { data: branchList, isLoading: isLoadingBranch } = useQuery({
    queryKey: [queryKeys.getSearchBranch, searchTxtBranch],
    queryFn: () => getSearchPatients('Branch', searchTxtBranch),
    enabled: searchTxtBranch?.length >= 2 || searchTxtBranch?.length === 0,
    keepPreviousData: true,
  });
  const { data: customer } = useQuery({
    queryKey: [queryKeys.getSearchApiAccountList, searchtextCustomer],
    queryFn: () =>
      getSearchApiSearchText({
        type: 'Customer',
        searchTxt: searchtextCustomer,
      }),
    keepPreviousData: true,

    enabled:
      searchtextCustomer?.length >= 3 || searchtextCustomer?.length === 0,
  });
  // custom_return_reason
  // return_against;
  const onFinish = (values) => {
    setLoadingAdd(true);
    onAddSalesInvoice({
      ...values,
      company: companyName,
      due_date: dayjs(values?.due_date).format('YYYY-MM-DD'),
      posting_date: dayjs(values?.posting_date).format('YYYY-MM-DD'),
      posting_time: dayjs(values?.posting_time).format('HH:mm:ss.SSSSSS'),
      service_unit: values?.custom_service_unit,
      grand_total: Number(values?.grand_total),
      items: dataSourceItem?.map((item) => ({ ...item })),
      // taxes: dataSourceTax?.length > 0 ? dataSourceTax : [],
      taxes: taxesDetails?.length > 0 ? taxesDetails : [],
      payment_schedule: dataSourcePayment?.map((payment) => ({
        due_date: dayjs(payment?.due_date).format('YYYY-MM-DD'),
        payment_amount: Number(payment?.payment_amount || 0),
        description: payment?.description,
        invoice_portion: Number(payment?.invoice_portion || 100),
      })),
    });
  };
  const { data: costCenters } = useQuery({
    queryKey: [queryKeys.getCostCentersSearch],
    queryFn: () => getSearchApi('Cost Center'),
    keepPreviousData: true,
  });
  const { data: priceList } = useQuery({
    queryKey: [queryKeys.getPriceListSearch],
    queryFn: () => getSearchApi('Price List'),
    keepPreviousData: true,
  });
  // const { data: vatTax } = useQuery({
  //   queryKey: [queryKeys.getVatTax],
  //   queryFn: () => getVatTax(),
  //   keepPreviousData: true,
  // });
  const { data: salesInvoice, isLoading: loadingSales } = useQuery({
    queryKey: [queryKeys.getSalesInvoiceDetails, id],
    queryFn: () => getSalesInvoiceDetails(id),
    keepPreviousData: true,
    enabled: !!edit,
  });
  const { data: salesIvoiceOrder, isLoading: loadingSalesInvoiceOrder } =
    useQuery({
      queryKey: [queryKeys.getSalesOrder, idOrder],
      queryFn: () => getSalesOrder(idOrder),
      keepPreviousData: true,
      enabled: !!idOrder,
    });
  const { data: salesOrderDetails, isLoading: loadingSalesOrder } = useQuery({
    queryKey: [queryKeys.createPartialSalesInvoice, idSalesOrder, idAmount],
    queryFn: () => createPartialSalesInvoice(idSalesOrder, idAmount),
    keepPreviousData: true,
    enabled: !!salesOrder,
  });
  const { data: fullPayment, isLoading: loadingFullPayment } = useQuery({
    queryKey: [queryKeys.createFullInvoice, idFullPayment],
    queryFn: () => createFullInvoice(idFullPayment),
    keepPreviousData: true,
    enabled: !!SalesFullPayment,
  });
  const { data: taxesCharges } = useQuery({
    queryKey: [queryKeys.getItemTaxTemplate],
    // queryFn: () => getSearchApi('Item Tax Template'),
    queryFn: () => getSearchApi('Sales Taxes and Charges Template'),
    keepPreviousData: true,
  });

  const { data: salesInvoiceNumber, isLoading: loadinginvoiceNumber } =
    useQuery({
      queryKey: [queryKeys.getSalesInvoiceDetails, invoiceNumber],
      queryFn: () => getSalesInvoiceDetails(invoiceNumber),
      keepPreviousData: true,
      enabled: !!invoiceNumber && !edit,
    });

  const isStatusDisabledFiled =
    salesInvoice?.message?.message?.docstatus === 1 ||
    salesInvoice?.message?.message?.docstatus === 2;
  const handleInvoiceCredit = (value) => {
    setLoadingSubmit(true);
    onCreditSalesInvoice();
  };

  const {
    ref_practitioner,
    custom_service_unit,
    service_unit,
    due_date,
    docstatus,
    custom_payment_method,
    items,
    taxes,
    total_taxes_and_charges,
    grand_total,
    status,
    outstanding_amount,
    name,
    payment_schedule,
    posting_date,
    posting_time,
    is_return,
  } = salesInvoice?.data || {};
  useEffect(() => {
    if (salesInvoice && edit) {
      setDataSourceItem(items?.length ? items : [{}]);
      setDataSourceTax(taxes?.length ? taxes : []);
      setTaxesDetails(taxes);
      setDataStatus(docstatus);
      setDataSourcePayment(
        payment_schedule?.length
          ? payment_schedule?.map((payment) => ({
              ...payment,
              due_date: dayjs(payment?.due_date),
            }))
          : [{}]
      );
      form.setFieldsValue({
        ...salesInvoice?.data,
        ref_practitioner: ref_practitioner,
        custom_service_unit: service_unit || custom_service_unit,
        due_date: dayjs(due_date),
        custom_payment_method: custom_payment_method,
        total_taxes_and_charges: total_taxes_and_charges,
        grand_total: grand_total,
        items: items?.length ? items : [{}],
        taxes: taxes?.length ? taxes : [{}],
        posting_date: dayjs(posting_date),
        posting_time: dayjs(posting_time, 'HH:mm'),
      });
    }
  }, [salesInvoice, form, edit]);
  useEffect(() => {
    if (salesOrderDetails?.message && salesOrder) {
      setDataSourceItem(
        salesOrderDetails?.message?.items?.length
          ? salesOrderDetails?.message?.items?.map((item) => ({
              ...item,
              // item_code: item?.description,
            }))
          : [{}]
      );
      setDataSourceTax(
        salesOrderDetails?.message?.taxes?.length
          ? salesOrderDetails?.message?.taxes
          : []
      );
      setTaxesDetails(salesOrderDetails?.message?.taxes);
      setDataStatus(salesOrderDetails?.message?.docstatus);
      setDataSourcePayment(
        salesOrderDetails?.message?.payment_schedule?.length
          ? salesOrderDetails?.message?.payment_schedule?.map((payment) => ({
              ...payment,
              due_date: dayjs(payment?.due_date),
            }))
          : [{}]
      );
      form.setFieldsValue({
        ...salesOrderDetails?.message,
        ref_practitioner: salesOrderDetails?.message?.ref_practitioner,
        custom_service_unit:
          salesOrderDetails?.message?.service_unit ||
          salesOrderDetails?.message?.custom_service_unit,
        due_date: dayjs(salesOrderDetails?.message?.due_date),
        custom_payment_method:
          salesOrderDetails?.message?.custom_payment_method,
        total_taxes_and_charges:
          salesOrderDetails?.message?.total_taxes_and_charges,
        grand_total: salesOrderDetails?.message?.grand_total,
        items: salesOrderDetails?.message?.items?.length
          ? salesOrderDetails?.message?.items
          : [{}],
        taxes: salesOrderDetails?.message?.taxes?.length
          ? salesOrderDetails?.message?.taxes
          : [{}],
        posting_date: dayjs(salesOrderDetails?.message?.posting_date),
        posting_time: dayjs(salesOrderDetails?.message?.posting_time, 'HH:mm'),
      });
    }
  }, [salesOrderDetails, form, salesOrder]);
  useEffect(() => {
    if (fullPayment?.message && SalesFullPayment) {
      setDataSourceItem(
        fullPayment?.message?.items?.length ? fullPayment?.message?.items : [{}]
      );
      setDataSourceTax(
        fullPayment?.message?.taxes?.length ? fullPayment?.message?.taxes : []
      );
      setDataStatus(fullPayment?.message?.docstatus);
      setDataSourcePayment(
        fullPayment?.message?.payment_schedule?.length
          ? fullPayment?.message?.payment_schedule?.map((payment) => ({
              ...payment,
              due_date: dayjs(payment?.due_date),
            }))
          : [{}]
      );
      form.setFieldsValue({
        ...fullPayment?.message,
        ref_practitioner: fullPayment?.message?.ref_practitioner,
        custom_service_unit:
          fullPayment?.message?.service_unit ||
          fullPayment?.message?.custom_service_unit,
        due_date: dayjs(fullPayment?.message?.due_date),
        custom_payment_method: fullPayment?.message?.custom_payment_method,
        total_taxes_and_charges: fullPayment?.message?.total_taxes_and_charges,
        grand_total: fullPayment?.message?.grand_total,
        items: fullPayment?.message?.items?.length
          ? fullPayment?.message?.items
          : [{}],
        taxes: fullPayment?.message?.taxes?.length
          ? fullPayment?.message?.taxes
          : [{}],
        posting_date: dayjs(fullPayment?.message?.posting_date),
        posting_time: dayjs(fullPayment?.message?.posting_time, 'HH:mm'),
      });
    }
  }, [fullPayment, form, SalesFullPayment]);
  useEffect(() => {
    if (salesInvoiceNumber && !edit) {
      setDataSourceItem(
        salesInvoiceNumber?.data?.items?.length
          ? salesInvoiceNumber?.data?.items
          : [{}]
      );
      setDataSourceTax(salesInvoiceNumber?.data?.taxes?.length ? taxes : []);
      // setDataStatus(docstatus);
      setDataSourcePayment(
        salesInvoiceNumber?.data?.payment_schedule?.length
          ? salesInvoiceNumber?.data?.payment_schedule?.map((payment) => ({
              ...payment,
              due_date: dayjs(payment?.due_date),
            }))
          : [{}]
      );
      form.setFieldsValue({
        ...salesInvoiceNumber?.data,
        ref_practitioner: salesInvoiceNumber?.data?.ref_practitioner,
        custom_service_unit: salesInvoiceNumber?.data?.custom_service_unit,
        due_date: dayjs(salesInvoiceNumber?.data?.due_date),
        custom_payment_method: salesInvoiceNumber?.data?.custom_payment_method,
        total_taxes_and_charges:
          salesInvoiceNumber?.data?.total_taxes_and_charges,
        grand_total: salesInvoiceNumber?.data?.grand_total,
        items: salesInvoiceNumber?.data?.items?.length
          ? salesInvoiceNumber?.data?.items
          : [{}],
        taxes: salesInvoiceNumber?.data?.taxes?.length
          ? salesInvoiceNumber?.data?.taxes
          : [{}],
        posting_date: dayjs(salesInvoiceNumber?.data?.posting_date),
        posting_time: dayjs(salesInvoiceNumber?.data?.posting_time, 'HH:mm'),
      });
    }
  }, [salesInvoiceNumber, form, edit]);
  useEffect(() => {
    if (idOrder && !edit) {
      setDataSourceItem(
        salesIvoiceOrder?.message?.items?.length
          ? salesIvoiceOrder?.message?.items
          : [{}]
      );
      setDataSourceTax(salesIvoiceOrder?.message?.taxes?.length ? taxes : []);
      // setDataStatus(docstatus);
      setDataSourcePayment(
        salesIvoiceOrder?.message?.payment_schedule?.length
          ? salesIvoiceOrder?.message?.payment_schedule?.map((payment) => ({
              ...payment,
              due_date: dayjs(payment?.due_date),
            }))
          : [{}]
      );
      form.setFieldsValue({
        ...salesIvoiceOrder?.message,
        ref_practitioner: salesIvoiceOrder?.message?.ref_practitioner,
        custom_service_unit: salesIvoiceOrder?.message?.custom_service_unit,
        due_date: dayjs(salesIvoiceOrder?.message?.due_date),
        custom_payment_method: salesIvoiceOrder?.message?.custom_payment_method,
        total_taxes_and_charges:
          salesIvoiceOrder?.message?.total_taxes_and_charges,
        grand_total: salesIvoiceOrder?.message?.grand_total,
        items: salesIvoiceOrder?.message?.items?.length
          ? salesIvoiceOrder?.message?.items
          : [{}],
        taxes: salesIvoiceOrder?.message?.taxes?.length
          ? salesIvoiceOrder?.message?.taxes
          : [{}],
        posting_date: dayjs(salesIvoiceOrder?.message?.posting_date),
        posting_time: dayjs(salesIvoiceOrder?.message?.posting_time, 'HH:mm'),
      });
      if (salesIvoiceOrder?.message?.taxes_and_charges) {
        onGetTaxes(salesIvoiceOrder?.message?.taxes_and_charges);
      }
    }
  }, [salesIvoiceOrder, idOrder, form, edit]);
  if (
    loadingSales ||
    loadingSalesOrder ||
    loadingFullPayment ||
    loadingSalesInvoiceOrder
  ) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '90vh',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  const LinkedDocs =
    status === 'Unpaid' || status === 'Paid' || status === 'Partly Paid';

  // console.log(LinkedDocs, 'LinkedDocs');

  // const itemsMenu = [
  //   {
  //     key: '1',
  //     label: (
  //       // status?.workflow_state === 'Scheduled' && (
  //       <Button
  //         type="text"
  //         size="small"
  //         disabled={docstatus !== 1}
  //         loading={loadingAdd}
  //         danger
  //       >
  //         {t.CancelInvoice}
  //       </Button>
  //     ),
  //     onClick: () => {
  //       setLoadingAdd(true);
  //       handleCancelSalesInvoice.mutate(id);
  //     },
  //   },

  //   {
  //     key: '2',
  //     label: (
  //       <Button
  //         type="text"
  //         size="small"
  //         disabled={is_return}
  //         loading={loadingAdd}
  //       >
  //         {t.reject}
  //       </Button>
  //     ),
  //     onClick: handleInvoiceCredit,
  //   },
  //   {
  //     key: '3',
  //     label: (
  //       <Button
  //         disabled={status !== 'Draft'}
  //         type="text"
  //         size="small"
  //         loading={isLoadingSubmit}
  //       >
  //         {t.submit}
  //       </Button>
  //     ),
  //     onClick: () => onSubmitSalesInvoice(name),
  //   },
  //   {
  //     key: '4',
  //     label: (
  //       <Button
  //         disabled={status !== 'Draft' || status !== 'Overdue'}
  //         type="text"
  //         size="small"
  //       >
  //         {t.paymentEntry}
  //       </Button>
  //     ),
  //     onClick: () => navigate(`/payment-entry/sales/${name}`),
  //   },
  //   {
  //     key: '5',
  //     label: (
  //       <Button
  //         type="text"
  //         size="small"
  //         disabled={
  //           status === 'Unpaid'
  //             ? false
  //             : status === 'Partly Paid'
  //             ? false
  //             : true
  //         }
  //       >
  //         {t.Payment}
  //       </Button>
  //     ),
  //     onClick: () => {
  //       setOpen(true);
  //       setEditId(name);
  //       setTotalPayment(outstanding_amount);
  //     },
  //   },
  //   {
  //     key: '6',
  //     label: (
  //       <Button type="text" size="small" disabled={!LinkedDocs}>
  //         {t.GetLinkedDocs}
  //       </Button>
  //     ),
  //     onClick: () => {
  //       setOpenLinkedDocs(true);
  //       setNameSalesInvoice(name);
  //     },
  //   },
  //   {
  //     key: '7',
  //     label: (
  //       <Button
  //         type="text"
  //         size="small"
  //         disabled={docstatus === 1 ? false : true}
  //       >
  //         {t.GeneralLedger}
  //       </Button>
  //     ),
  //     onClick: () => {
  //       navigate(`/general-ledger-report-sales/${id}`);
  //     },
  //   },
  // ];
  const itemsMenu = (record) => [
    {
      key: '2',
      label: t.Payment,
      icon: <MdOutlinePayment />,
      disabled: record?.status === 'Paid' ? true : false,
      onClick: () => {
        setOpen(true);
        setEditId(id);
        setTotal(record?.outstanding_amount);
      },
    },
    {
      key: '2-2',
      label: t.reject,
      icon: <TiCancel />,
      disabled: record?.status === 'Paid' ? true : false,
      // label: (
      //   <Button
      //     type="text"
      //     size="small"
      //     disabled={is_return}
      //     loading={loadingAdd}
      //   >
      //     {t.reject}
      //   </Button>
      // ),
      onClick: handleInvoiceCredit,
    },
    {
      key: '3',
      label: t.paymentEntry,
      icon: <FaMoneyBillWave />,
      disabled: record?.status === 'Paid' ? true : false,
      onClick: () => navigate(`/payment-entry/sales/${id}`),
    },
    {
      key: '6-6',
      label: t.GetLinkedPayments,
      icon: <MdOutlinePayment />,
      disabled: credit ? false : LinkedDocs ? false : true,
      // label: (
      //   <Button type="text" size="small" disabled={!LinkedDocs}>
      //     {t.GetLinkedPayments}
      //   </Button>
      // ),
      onClick: () => {
        setOpenLinkedDocs(true);
        setNameSalesInvoice(name);
      },
    },
    {
      key: '4',
      label: t.GeneralLedger,
      icon: <GiFiles />,
      disabled: credit ? false : record?.docstatus === 1 ? false : true,
      onClick: () => navigate(`/general-ledger-report-sales/${id}`),
    },
    {
      type: 'divider',
    },
    {
      key: '5',
      label: t.SubmittheSalesInvoice,
      disabled: record?.status === 'Draft' ? false : true,
      icon: <CheckOutlined />,
      onClick: () => onSubmitSalesInvoice(id),
    },
    {
      key: '5-1',
      label: t.SubmitToZatca,
      // disabled: record.status === 'Draft' ? false : true,

      icon: <CheckOutlined />,
      onClick: () => {
        onSubmitToZatca(id);
      },
    },
    {
      key: '5-2',
      label: t.downloadZatcaPdf,
      // disabled: record.status === 'Draft' ? false : true,

      icon: <DownloadOutlined />,
      onClick: () => {
        onDownloadZatca({
          // type: 'Sales Invoice',
          name: id,
          lang: currentLang,
          format: '',
        });
        setNameInvoiceZatca(id);
        setOpenPdfZatca(true);
      },
    },
    {
      key: '5-3',
      label: t.downloadZatcaXML,
      // disabled: record.status === 'Draft' ? false : true,

      icon: <DownloadOutlined />,
      onClick: () => onDownloadZatcaXml(id),
    },
    {
      key: '5-4',
      label: t.GetZatcaDetails,
      // disabled: record.status === 'Draft' ? false : true,

      icon: <CheckOutlined />,
      onClick: () => onGetZatcaDetails(id),
    },
    // {
    //   key: '5-1',
    //   label: t.SubmitToZatca,
    //   // disabled: record.status === 'Draft' ? false : true,

    //   icon: <CheckOutlined />,
    //   onClick: () => onSubmitToZatca(id),
    // },
    {
      key: '6',
      label: t.getPDF,
      icon: <CheckOutlined />,
      onClick: () => {
        onGetPDF({
          type: 'Sales Invoice',
          name: id,
          lang: currentLang,
          format: '',
        });
        setOpenPdf(true);
      },
    },
    credit
      ? null
      : {
          key: '7',
          label: t.CreditNote,
          // disabled: record?.docstatus === 1 ? false : true,
          icon: <FaMoneyBillTrendUp />,
          onClick: () => handleCreditNote.mutate(id),
        },
    {
      key: '77',
      label: t.AssignTask,
      icon: <MdAssignmentAdd />,
      onClick: () => {
        setOpenTask(true);
      },
    },
  ];
  return (
    <div className="sales-invoice-add">
      {/* <Heading
        title={t.salesInvoice}
        subTitle={t.AddSalesInvoice}
        status={status}
        path="/sales-invoice"
      /> */}
      <HeadingApp
        nameTab={t.SalesFinance}
        title={credit ? t.creditNote : t.salesInvoice}
        subTitle={
          credit ? t.creditNote : edit ? t.EditSalesInvoice : t.AddSalesInvoice
        }
        icon={<FaFileInvoice />}
      />
      <Card style={{ borderRadius: '0px' }}>
        <Flex justify="space-between">
          <h4 className="title-card">{t.ENTERSALESINVOICEINFORMATION}</h4>
          {edit && (
            <Dropdown
              menu={{ items: itemsMenu(salesOrderDetails?.message) }}
              trigger={['click']}
              arrow
              className="btn-light"
              // onClick={() => setStatus(record)}
            >
              <Button size="small" type="text">
                {t.action}
                <DownOutlined />
              </Button>
            </Dropdown>
          )}
        </Flex>
        <Form
          layout="vertical"
          name="nest-messages"
          onFinish={onFinish}
          form={form}
          disabled={isStatusDisabledFiled}
          initialValues={{
            items: [{}],
            taxes: [{}],
          }}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={24} lg={18}>
              <Divider orientation="left">{t.SalesInvoiceInformation}</Divider>
              <Row gutter={[16, 0]}>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="customer"
                    label={t.Customer}
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.Customer}
                      style={{ width: '100%' }}
                      showSearch
                      filterOption={false}
                      popupMatchSelectWidth={false}
                      // options={customer?.message?.map((item) => ({
                      //   value: item?.value,
                      //   label: item?.value,
                      // }))}
                      onChange={(value) => {
                        handleGetDetails(value);
                      }}
                      onSearch={(value) => setSearchtextCustomer(value)}
                    >
                      {customer?.message?.map((item) => (
                        <Select.Option key={item?.value}>
                          <Flex gap={1} vertical>
                            <span>{item?.value}</span>
                            <span
                              className="item-description"
                              style={{ fontSize: '11px', color: 'gray' }}
                            >
                              {item?.description}
                            </span>
                          </Flex>
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                {/* <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="customer_name_in_arabic"
                    label={t.customerNameInArabic}
                    // rules={[{ required: true }]}
                  >
                    <Input placeholder={t.customerNameInArabic} disabled />
                  </Form.Item>
                </Col> */}
                {/* <Col xs={24} md={12} xl={8} xxl={8}>
              <Form.Item
                name="tax_id"
                label={t.taxId}
                // rules={[{  : true }]}
              >
                <Input placeholder={t.taxId} disabled />
              </Form.Item>
            </Col> */}
                {/* <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="custom_vat_registration_number"
                    label={t.custom_vat_registration_number}
                  >
                    <Input
                      placeholder={t.custom_vat_registration_number}
                      type="number"
                      disabled
                    />
                  </Form.Item>
                </Col> */}

                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="custom_user_invoice_number"
                    label={t.custom_user_invoice_number}
                    // rules={[{ required: true }]}
                  >
                    <Input
                      placeholder={t.custom_user_invoice_number}
                      type="number"
                    />
                  </Form.Item>
                </Col>
                {credit && (
                  <Col xs={24} md={12} xl={8} xxl={8}>
                    <Form.Item
                      name="return_against"
                      label={t.return_against}
                      // rules={[{ required: true }]}
                    >
                      <Input placeholder={t.return_against} disabled />
                    </Form.Item>
                  </Col>
                )}
                {/* <Col
                  xs={24}
                  md={12}
                  xl={8}
                  xxl={8}
                  className="flex items-center justify-start"
                >
                  <Form.Item
                    name="custom_b2c"
                    // label={t.custom_b2c}
                    // rules={[{ required: true }]}
                    valuePropName="checked"
                    className="margin-bottom-0"
                  >
                    <Checkbox disabled>{t.custom_b2c}</Checkbox>
                  </Form.Item>
                </Col> */}
                {/* <Col xs={24} md={12} xl={8} xxl={8}></Col> */}
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="due_date"
                    label={t.paymentDueDate}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    initialValue={dayjs()}
                    style={{ width: '100%' }}
                  >
                    <DatePicker
                      placeholder={t.paymentDueDate}
                      format="YYYY-MM-DD"
                      style={{ width: '100%' }}
                      // disabledDate={(current) =>
                      //   current.endOf('d').valueOf() <
                      //   dayjs().endOf('d').valueOf()
                      // }
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="posting_date"
                    label={t.postingDate}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    initialValue={dayjs()}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder={t.postingDate}
                      disabled={
                        salesOrderDetails?.message?.docstatus === 1
                          ? true
                          : false
                      }
                      format="YYYY-MM-DD"
                      // disabledDate={(current) =>
                      //   current.endOf('d').valueOf() <
                      //   dayjs().endOf('d').valueOf()
                      // }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="posting_time"
                    label={t.postingTime}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    initialValue={dayjs()}
                  >
                    <TimePicker
                      style={{ width: '100%' }}
                      // disabled={view}
                      placeholder={t.postingTime}
                      format="HH:mm"
                    />
                  </Form.Item>
                </Col>
                {credit && (
                  <Col span={24}>
                    <Form.Item
                      name="custom_return_reason"
                      label={t.custom_return_reason}
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Input.TextArea
                        autoSize={{ minRows: 3, maxRows: 4 }}
                        placeholder={t.custom_return_reason}
                      />
                    </Form.Item>
                  </Col>
                )}

                <Divider orientation="left">{t.currencyAndPriceList}</Divider>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="selling_price_list"
                    label={t.sellingPriceList}
                  >
                    <Select
                      placeholder={t.sellingPriceList}
                      showSearch
                      // disabled={view}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      onChange={(value, option) => {
                        // setPriceListSelect(value);
                        form.setFieldsValue({
                          price_list_currency: option?.option?.description,
                          currency: option?.option?.description,
                        });
                      }}
                      options={priceList?.message?.map((item) => ({
                        value: item?.value,
                        label: item?.value,
                        option: item,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="cost_center"
                    label={t.costCenter}
                    style={{ width: '100%', marginBottom: '0px' }}
                  >
                    <Select
                      placeholder={t.costCenter}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={costCenters?.message?.map((item) => ({
                        value: item?.value,
                        label: item?.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="branch"
                    label={t.branch}
                    rules={[
                      {
                        required: !edit
                          ? true
                          : status === 'Draft'
                          ? true
                          : false,
                      },
                    ]}
                    style={{ width: '100%', marginBottom: '0px' }}
                  >
                    <Select
                      placeholder={t.branch}
                      showSearch
                      disabled={
                        !edit ? false : status === 'Draft' ? false : true
                      }
                      popupMatchSelectWidth={false}
                      loading={isLoadingBranch}
                      onSearch={(value) => {
                        setSearchTxtBranch(value);
                      }}
                      options={branchList?.message?.map((item) => ({
                        value: item?.value,
                        label: item?.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Divider orientation="left">{t.items}</Divider>
                <Col span={24} className="items-form-add">
                  <ItemListSalesInvoice
                    // edit={edit}
                    // vatTax={vatTax}
                    priceList={watchPriceList || ''}
                    setDataSourceTax={setDataSourceTax}
                    // isNationalitySaudi={isNationalitySaudi}
                    form={form}
                    setDataSource={setDataSourceItem}
                    setDataSourcePayment={setDataSourcePayment}
                    dataSource={dataSourceItem}
                    t={t}
                  />
                </Col>
                <Divider orientation="left">{t.taxes}</Divider>

                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="taxes_and_charges"
                    label={t.TaxesandCharges}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Select
                      placeholder={t.TaxesandCharges}
                      style={{ width: '100%' }}
                      popupMatchSelectWidth={false}
                      allowClear
                      onChange={(value) => {
                        setLoadingTaxesDetails(true);
                        onGetTaxes(value);
                      }}
                      options={taxesCharges?.message?.map((item) => ({
                        value: item?.value,
                        label: item?.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                {/* <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="custom_zatca_tax_category"
                    label={t.custom_zatca_tax_category}
                    // rules={[{ required: true }]}
                    initialValue={'Standard'}
                  >
                    <Select
                      placeholder={t.custom_zatca_tax_category}
                      popupMatchSelectWidth={false}
                      style={{ width: '100%' }}
                      options={[
                        {
                          value: 'Standard',
                          label: 'Standard',
                        },
                        {
                          value: 'Zero Rated',
                          label: 'Zero Rated',
                        },
                        {
                          value: 'Exempted',
                          label: 'Exempted',
                        },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="custom_exemption_reason_code"
                    label={t.custom_exemption_reason_code}
                    rules={[{ required: true }]}
                    initialValue={'Standard 15%'}
                  >
                    <Select
                      placeholder={t.custom_exemption_reason_code}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={[
                        {
                          value: 'Standard 15%',
                          label: 'Standard 15%',
                        },
                        {
                          value: 'VATEX-SA-29',
                          label: 'VATEX-SA-29',
                        },
                        {
                          value: 'VATEX-SA-29-7',
                          label: 'VATEX-SA-29-7',
                        },
                        {
                          value: 'VATEX-SA-30',
                          label: 'VATEX-SA-30',
                        },
                        {
                          value: 'VATEX-SA-32',
                          label: 'VATEX-SA-32',
                        },
                        {
                          value: 'VATEX-SA-33',
                          label: 'VATEX-SA-33',
                        },
                        {
                          value: 'VATEX-SA-34-1',
                          label: 'VATEX-SA-34-1',
                        },
                        {
                          value: 'VATEX-SA-34-2',
                          label: 'VATEX-SA-34-2',
                        },
                        {
                          value: 'VATEX-SA-34-3',
                          label: 'VATEX-SA-34-3',
                        },
                        {
                          value: 'VATEX-SA-34-4',
                          label: 'VATEX-SA-34-4',
                        },
                        {
                          value: 'VATEX-SA-34-5',
                          label: 'VATEX-SA-34-5',
                        },
                        {
                          value: 'VATEX-SA-35',
                          label: 'VATEX-SA-35',
                        },
                        {
                          value: 'VATEX-SA-36',
                          label: 'VATEX-SA-36',
                        },
                        {
                          value: 'VATEX-SA-EDU',
                          label: 'VATEX-SA-EDU',
                        },
                        {
                          value: 'VATEX-SA-HEA',
                          label: 'VATEX-SA-HEA',
                        },
                        {
                          value: 'VATEX-SA-MLTRY',
                          label: 'VATEX-SA-MLTRY',
                        },
                        {
                          value: 'VATEX-SA-OOS',
                          label: 'VATEX-SA-OOS',
                        },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="custom_zatca_discount_reason_code"
                    label={t.custom_zatca_discount_reason_code}
                    // rules={[{ required: true }]}
                  >
                    <Input placeholder={t.custom_zatca_discount_reason_code} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="custom_zatca_discount_reason"
                    label={t.custom_zatca_discount_reason}
                    // rules={[{ required: true }]}
                  >
                    <Input placeholder={t.custom_zatca_discount_reason} />
                  </Form.Item>
                </Col> */}

                {/* {edit && (
                  <>
                    <Col xs={24} md={12} xl={8} xxl={8}>
                      <Form.Item
                        name="custom_uuid"
                        label={t.custom_uuid}
                        rules={[{ required: true }]}
                      >
                        <Input placeholder={t.custom_uuid} disabled />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12} xl={8} xxl={8}>
                      <Form.Item
                        name="custom_zatca_status"
                        label={t.custom_zatca_status}
                        // rules={[{ required: true }]}
                      >
                        <Input placeholder={t.custom_zatca_status} disabled />
                      </Form.Item>
                    </Col>
                  </>
                )} */}
                {/* <Divider orientation="left">{t.zatcaInvoiceType}</Divider> */}
                {/* <Divider orientation="left">{t.taxes}</Divider> */}
                {/* <Col
                  xs={24}
                  md={12}
                  xl={8}
                  xxl={8}
                  className="flex items-center justify-start"
                >
                  <Form.Item
                    name="custom_submit_line_item_discount_to_zatca"
                    // label={t.customZatcaThirdPartyInvoice}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                    valuePropName="checked"
                    className="margin-bottom-0"
                  >
                    <Checkbox>
                      {t.custom_submit_line_item_discount_to_zatca}
                    </Checkbox>
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  md={12}
                  xl={8}
                  xxl={8}
                  className="flex items-center justify-start"
                >
                  <Form.Item
                    name="custom_zatca_third_party_invoice"
                    // label={t.customZatcaThirdPartyInvoice}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                    className="margin-bottom-0"
                    valuePropName="checked"
                  >
                    <Checkbox>{t.customZatcaThirdPartyInvoice}</Checkbox>
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  md={12}
                  xl={8}
                  xxl={8}
                  className="flex items-center justify-start"
                >
                  <Form.Item
                    name="custom_zatca_nominal_invoice"
                    // label={t.customZatcaNominalInvoice}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                    className="margin-bottom-0"
                    valuePropName="checked"
                  >
                    <Checkbox>{t.customZatcaNominalInvoice}</Checkbox>
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  md={12}
                  xl={8}
                  xxl={8}
                  className="flex items-center justify-start"
                >
                  <Form.Item
                    name="custom_zatca_export_invoice"
                    // label={t.customZatcaExportInvoice}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                    className="margin-bottom-0"
                    valuePropName="checked"
                  >
                    <Checkbox>{t.customZatcaExportInvoice}</Checkbox>
                  </Form.Item>
                </Col> */}
                {/* <Col
                  xs={24}
                  md={12}
                  xl={8}
                  xxl={8}
                  className="flex items-center justify-start"
                >
                  <Form.Item
                    name="custom_summary_invoice"
                    // label={t.customSummaryInvoice}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                    className="margin-bottom-0"
                    valuePropName="checked"
                  >
                    <Checkbox>{t.customSummaryInvoice}</Checkbox>
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  md={12}
                  xl={8}
                  xxl={8}
                  className="flex items-center justify-start"
                >
                  <Form.Item
                    name="custom_self_billed_invoice"
                    // label={t.customSelfBilledInvoice}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                    valuePropName="checked"
                    className="margin-bottom-0"
                  >
                    <Checkbox>{t.customSelfBilledInvoice}</Checkbox>
                  </Form.Item>
                </Col> */}

                <Col span={24} className="mt-5">
                  <TaxtList
                    t={t}
                    form={form}
                    data={taxesDetails}
                    loadingTaxesDetails={loadingTaxesDetails}
                  />
                </Col>
                {/* <Col span={24} className="items-form-add">
              <TaxesandChargesList
                edit={edit}
                form={form}
                setDataSource={setDataSourceTax}
                dataSource={dataSourceTax}
                t={t}
              />
            </Col> */}
                <Divider orientation="left">{t.paymentSchedule}</Divider>
                <Col span={24}>
                  <PaymentSchedule
                    dataSourcePayment={dataSourcePayment}
                    setDataSourcePayment={setDataSourcePayment}
                    t={t}
                    type="sales"
                    form={form}
                  />
                </Col>
                <Divider orientation="left">{t.Total}</Divider>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="total_taxes_and_charges"
                    style={{ width: '100%', marginBottom: '0px' }}
                    label={t.TotalTaxesandCharges}
                  >
                    <Input
                      placeholder={t.Total}
                      style={{ width: '100%' }}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="grand_total"
                    style={{ width: '100%', marginBottom: '0px' }}
                    label={t.GrandTotal}
                  >
                    <Input
                      placeholder={t.GrandTotal}
                      style={{ width: '100%' }}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="total"
                    label={t.Total}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Input
                      placeholder={t.Total}
                      type="number"
                      min={0}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="total_qty"
                    label={t.totalQty}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Input
                      placeholder={t.totalQty}
                      type="number"
                      min={0}
                      disabled
                    />
                  </Form.Item>
                </Col>
                {/* <Col xs={12} md={8} xl={8} xxl={8}>
              <Form.Item
                name="total_taxes_and_charges"
                label={t.TotalTaxesandCharges}
                // rules={[
                //   {
                //     required: true,
                //   },
                // ]}
              >
                <Input
                  placeholder={t.TotalTaxesandCharges}
                  type="number"
                  min={0}
                  disabled
                />
              </Form.Item>
            </Col> */}
                {/* <Col xs={12} md={8} xl={8} xxl={8}>
              <Form.Item
                name="grand_total"
                label={t.grandTotal}
                // rules={[
                //   {
                //     required: true,
                //   },
                // ]}
              >
                <Input
                  placeholder={t.grandTotal}
                  type="number"
                  min={0}
                  disabled
                />
              </Form.Item>
            </Col> */}
                {edit ? (
                  <>
                    <Col xs={24} md={12} xl={8} xxl={8}>
                      <Form.Item
                        name="rounding_adjustment"
                        label={t.roundingAdjustment}
                      >
                        <Input
                          placeholder={t.roundingAdjustment}
                          type="number"
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12} xl={8} xxl={8}>
                      <Form.Item
                        name="rounded_total"
                        label={t.roundedTotal}
                        // rules={[
                        //   {
                        //     required: true,
                        //   },
                        // ]}
                        disabled
                      >
                        <Input
                          placeholder={t.roundedTotal}
                          type="number"
                          min={0}
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12} xl={8} xxl={8}>
                      <Form.Item name="in_words" label={t.inWords}>
                        <Input placeholder={t.inWords} disabled />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12} xl={8} xxl={8}>
                      <Form.Item name="total_advance" label={t.totalAdvance}>
                        <Input placeholder={t.totalAdvance} disabled />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12} xl={8} xxl={8}>
                      <Form.Item
                        name="outstanding_amount"
                        label={t.outstandingAmount}
                      >
                        <Input placeholder={t.outstandingAmount} disabled />
                      </Form.Item>
                    </Col>
                  </>
                ) : invoiceNumber ? (
                  <>
                    <Col xs={24} md={12} xl={8} xxl={8}>
                      <Form.Item
                        name="rounding_adjustment"
                        label={t.roundingAdjustment}
                      >
                        <Input
                          placeholder={t.roundingAdjustment}
                          type="number"
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12} xl={8} xxl={8}>
                      <Form.Item
                        name="rounded_total"
                        label={t.roundedTotal}
                        // rules={[
                        //   {
                        //     required: true,
                        //   },
                        // ]}
                        disabled
                      >
                        <Input
                          placeholder={t.roundedTotal}
                          type="number"
                          min={0}
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12} xl={8} xxl={8}>
                      <Form.Item name="in_words" label={t.inWords}>
                        <Input placeholder={t.inWords} disabled />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12} xl={8} xxl={8}>
                      <Form.Item name="total_advance" label={t.totalAdvance}>
                        <Input placeholder={t.totalAdvance} disabled />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12} xl={8} xxl={8}>
                      <Form.Item
                        name="outstanding_amount"
                        label={t.outstandingAmount}
                      >
                        <Input placeholder={t.outstandingAmount} disabled />
                      </Form.Item>
                    </Col>
                  </>
                ) : null}
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="apply_discount_on"
                    label={t.applyDiscountOn}
                    // rules={[
                    //   {
                    //       required: true,
                    //     },
                    // ]}
                  >
                    <Select
                      placeholder={t.applyDiscountOn}
                      options={[
                        {
                          value: 'Grand Total',
                          label: t.GrandTotal,
                        },
                        {
                          value: 'Net Total',
                          label: t.netTotal,
                        },
                      ]}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="discount_type"
                    label={t.discountType}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Select
                      placeholder={t.discountType}
                      style={{ width: '100%' }}
                      options={[
                        {
                          value: 'Percentage',
                          label: t.percentage,
                        },
                        {
                          value: 'Amount',
                          label: t.amount,
                        },
                      ]}
                    />
                  </Form.Item>
                </Col>
                {disountApplyType === 'Amount' && (
                  <Col xs={24} md={12} xl={8} xxl={8}>
                    <Form.Item name="base_discount_amount" label={t.value}>
                      <Input
                        placeholder={t.value}
                        type="number"
                        // disabled
                      />
                    </Form.Item>
                  </Col>
                )}
                {disountApplyType === 'Percentage' && (
                  <Col xs={24} md={12} xl={8} xxl={8}>
                    <Form.Item
                      name="additional_discount_percentage"
                      label={t.value}
                    >
                      <Input
                        placeholder={t.value}
                        type="number"
                        // disabled
                      />
                    </Form.Item>
                  </Col>
                )}
              </Row>
              <div className="form-btns">
                <Button
                  type="primary"
                  ghost
                  onClick={() => navigate('/sales-invoice')}
                >
                  {t.Cancel}
                </Button>
                <Button
                  type="primary"
                  // block
                  loading={loadingAdd}
                  onClick={() => {
                    if (submitButton) {
                      setLoadingAdd(true);
                      onSubmitSalesInvoice(invoiceNumber);
                    } else {
                      form.submit();
                    }
                  }}
                >
                  {submitButton
                    ? t.submit + ' ' + t.salesInvoice
                    : edit
                    ? t.edit + ' ' + t.salesInvoice
                    : t.Save + ' ' + t.salesInvoice}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Card>
      <ModalAppPayment
        open={open}
        setOpen={setOpen}
        editId={editId}
        t={t}
        total={totalPayment}
      />
      <ModalGetLinkedDocs
        open={openLinkedDocs}
        setOpen={setOpenLinkedDocs}
        name={nameSalesInvoice}
        setName={setNameSalesInvoice}
        t={t}
      />
      <ModalAppPdfData
        open={openPdf}
        pdfData={pdfData}
        setOpen={setOpenPdf}
        nameInvoice={id}
        t={t}
        onGetPDF={onGetPDF}
        type="Sales Invoice"
        setLoadingPdf={setLoadingPdf}
        loadingPdf={loadingPdf}
      />
      <ModalAppPdfData
        open={openPdfZatca}
        pdfData={pdfDataZatca}
        setOpen={setOpenPdfZatca}
        nameInvoice={nameInvoiceZatca}
        t={t}
        onGetPDF={onDownloadZatca}
        type="Sales Invoice"
        setLoadingPdf={setLoadingPdf}
        loadingPdf={loadingPdf}
      />
      <ModalTodoList
        open={openTask}
        setOpen={setOpenTask}
        editId={id}
        doctype="Sales Invoice"
        t={t}
      />
      <Modal
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        footer={null}
        centered
        // title="تفاصيل ZATCA"
        title={t.zatcaDetails}
        width={800}
      >
        {zatcaData && (
          <Descriptions column={1} bordered>
            <Descriptions.Item label={t.status}>
              {/* {zatcaData.status} */}
              <StatusTag status={zatcaData.status} />
            </Descriptions.Item>
            {/* <Descriptions.Item label="حالة ZATCA"> */}
            <Descriptions.Item label={t.zatcaStatus}>
              {zatcaData.zatca_status}
            </Descriptions.Item>
            {/* {zatcaData.validationResults?.map((item, index) => (
                    <Descriptions.Item
                      label={`${t.message} ${index + 1}`}
                      key={index}
                    >
                      <span
                        style={{
                          color:
                            item.type === 'ERROR'
                              ? 'red'
                              : item.type === 'WARNING'
                              ? 'orange'
                              : 'green',
                        }}
                      >
                        {item.message}
                      </span>
                    </Descriptions.Item>
                  ))} */}

            {/* {Array.isArray(zatcaData?.validationResults) &&
                    zatcaData.validationResults.map((item, index) => (
                      <Descriptions.Item
                        label={`${t.message} ${index + 1}`}
                        key={index}
                      >
                        <span
                          style={{
                            color:
                              item.type === 'ERROR'
                                ? 'red'
                                : item.type === 'WARNING'
                                ? 'orange'
                                : 'green',
                          }}
                        >
                          {item.message}
                        </span>
                      </Descriptions.Item>
                    ))} */}
            <Descriptions.Item label={`${t.message}`}>
              {Array.isArray(zatcaData?.validationResults) &&
                zatcaData.validationResults.map((item, index) => (
                  <span key={index}>{item.message}</span>
                ))}
            </Descriptions.Item>

            {/* {zatcaData.validationResults?.infoMessages?.map((item, index) => (
                    <Descriptions.Item
                      label={`${t.message} ${index + 1}`}
                      key={index}
                    >
                      {item.message}
                    </Descriptions.Item>
                  ))} */}
          </Descriptions>
        )}
      </Modal>
    </div>
  );
};

export default SalesInvoiceAdd;
